import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PrintPdfService } from './angularjs/estensa-print.service';
import { CacheService } from '../utils/cache.service';
import { ServerRootService } from '../utils/routing/serverroot.service';

@Injectable({
    providedIn: 'root',
})
export class PdfService extends ServerRootService {

    // constructor

    constructor(
        private httpClient: HttpClient,
        private cacheService: CacheService,
        private printService: PrintPdfService) {
        super();
    }

    // public functions

    getPdf(url: string) {
        return this.httpClient.get(url, { responseType: 'arraybuffer' });
    }

    getEmptyPdf() {
        return this.cacheService.get("emptyPdf", this.getPdf(this.getAssetsRoot() + 'empty_PDF_template.pdf'));
    }

    convertDataURIToBinary(dataURI) {

        const raw = window.atob(dataURI);
        const rawLength = raw.length;
        const array = new Uint8Array(new ArrayBuffer(rawLength));

        for (let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }

        return array;
    }

    print(pdfData: ArrayBuffer | Uint8Array, _?: string) {
        this.printService.print(pdfData);
    }
}
